module.exports = __webpack_public_path__ + "img/brushes-mobile_cn.bc7a1dd.jpg";